import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../modules/auth-core/data/service/authentication.service';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthenticationService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const isLoggedIn = this.authService.token != null;

        // if not logged in, then send them to the auction list page
        // this will show them they need to sign-in and then they can
        //   console.log('AuthGuard#canActivate called', next, state, this.router);
        if (!isLoggedIn) {
            const newUrl = next.paramMap.has('code') ? `/auction/${next.params.code}/browse` : '/auth/login';
            // Navigate to the new URL
            this.router.navigate([newUrl]);
        }

        return isLoggedIn;
    }
}
